<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Call Group</h1>
        <div class="modal-actions col-2">
          <el-button
            type="primary"
            @click="createOperation"
            :disabled="numUsed"
          >
            Create
          </el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <el-tabs v-model="activeTabName">
        <el-tab-pane label="General" name="general">
          <div class="inline-form-group">
            <el-col :span="11">
              <el-input
                v-model="createForm.number"
                placeholder="Call group extension"
              >
                <template slot="prefix">Call group extension</template>
                <template slot="append" v-if="numUsed">
                  <in-use :inUse="numInUse" />
                </template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="12">
              <el-input v-model="createForm.name" placeholder="Call group name">
                <template slot="prefix">Call group name</template>
              </el-input>
            </el-col>
          </div>

          <dads-select
            v-model="createForm.branchId"
            placeholder="Branch"
            filterable
          >
            <template slot="prefix"> Branch</template>
            <el-option
              v-for="branch in branchOptions"
              :key="branch.id"
              :value="branch.id"
              :label="branch.name"
            />
          </dads-select>

          <div class="inline-form-group">
            <el-checkbox v-model="createForm.usemoh" :label="true">
              <span>Enable music on hold</span>
            </el-checkbox>
          </div>
          <div class="inline-form-group">
            <el-checkbox v-model="createForm.checkinuse" :label="true">
              <span>Enable skipping extension if on a call</span>
            </el-checkbox>
          </div>

          <h2 class="form-section-header">Ring strategy</h2>
          <div class="mv-10">
            <el-radio-group v-model="ringStrategy" class="black-text">
              <el-radio label="RINGALL">
                <span class="black-text">Ring all</span>
              </el-radio>
              <el-radio label="SEQUENCE">
                <span class="black-text">Sequence</span>
              </el-radio>
            </el-radio-group>
          </div>
          <div class="inline-form-group" v-if="ringStrategy === 'SEQUENCE'">
            <el-checkbox v-model="enableLooping" :label="true">
              <span>Enable looping</span>
            </el-checkbox>
          </div>
          <div class="inline-form-group">
            <el-col :span="11">
              <el-select
                v-model="createForm.ringTime"
                placeholder="Select ring time (rings)"
              >
                <el-option v-for="i in 60" :key="i" :label="i" :value="i * 5" />
                <template slot="prefix">Ring time (rings)</template>
              </el-select>
            </el-col>
            <el-col :span="1" />
            <el-col :span="12" v-if="ringStrategy === 'SEQUENCE'">
              <el-select
                v-model="createForm.dialTimeout"
                placeholder="Select dial timeout (rings)"
              >
                <el-option
                  v-for="i in 120"
                  :key="i"
                  :label="i"
                  :value="i * 5"
                />
                <template slot="prefix">Dial timeout (rings)</template>
              </el-select>
            </el-col>
          </div>

          <h2 class="form-section-header">Timeout Destination</h2>
          <destination-selector
            :isTerminalDestSelector="true"
            :draggable="true"
            :showHeader="false"
            :draggableDestTypes="draggableDestTypes"
              :include-pharmacy-dests="true"
                :include-pharmacy-agents="true"
            :selectedDestinations="createForm.timeoutDestinations"
            @destinationsSelected="onTimeoutDestinationsSelection"
            title=""
            :clearFields="clearFormFields"
          />

          <h2 class="form-section-header">Unconditional forwarding</h2>
          <el-checkbox v-model="createForm.unconditionalStatus"
            >Enable unconditional forwarding</el-checkbox
          >
          <div v-if="createForm.unconditionalStatus">
            <h2 class="form-section-header">Unconditional Destinations</h2>
            <destination-selector
              :isTerminalDestSelector="true"
              :draggable="true"
              :showHeader="false"
              :draggableDestTypes="draggableDestTypes"
              :include-pharmacy-dests="true"
                :include-pharmacy-agents="true"
              :selectedDestinations="createForm.unconditionalDestinations"
              :clearFields="clearFields"
              @destinationsSelected="onUnconditionalDestinationsSelection"
              title=""
            />
          </div>
        </el-tab-pane>
        <!-- DESTINATIONS -->
        <el-tab-pane label="Destinations" name="destinations">
          <destination-selector
            :maxDests="maxDests"
            :draggable="true"
            :draggableDestTypes="['CUSTOM', 'EXT']"
            :clearFields="clearFormFields"
            @destinationsSelected="onDestinationsSelection"
            title=""
          />
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </el-dialog>
</template>

<script>
import DestinationSelector from "@/components/DestinationSelector.vue";
import InUse from "@/components/InUse.vue";
import DadsSelect from "@/components/select";
import feathersClient from "@/feathers/feathers-client";

export default {
  name: "HuntListCreateForm",

  props: {
    createVisible: { required: true },
    numInUse: { required: true },
    clearFormFields: { required: true },
    createProcessing: { required: true },
    draggableDestTypes: { required: true },
    branchOptions: { required: true },
  },

  components: {
    DestinationSelector,
    InUse,
    DadsSelect,
  },

  data() {
    return {
      activeTabName: "general",
      ringStrategy: "RINGALL",
      enableLooping: false,
      requestConfirm: false,
      createForm: {
        tenantId: null,
        number: null,
        name: "",
        ringTime: null,
        type: "",
        dialTimeout: null,
        usemoh: false,
        checkinuse: false,
        destinations: [],
        phoneNums: [],
        timeoutDestinations: [],
        unconditionalDestinations: [],
        unconditionalStatus: "",
        requestConfirm: false,
        branchId: [],
      },
    };
  },
  async created() {
    await this.getDefaultBranch();
  },
  computed: {
    callGroupNumber() {
      return this.createForm.number;
    },

    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    maxDests() {
      return this.ringStrategy === "RINGALL" ? 50 : 75;
    },

    numUsed() {
      return this.numInUse && this.numInUse.inUse;
    },
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
        this.getDefaultBranch();
      }
    },

    callGroupNumber() {
      if (this.callGroupNumber) {
        this.$emit("numberChange", this.callGroupNumber);
      }
    },
  },

  methods: {
    async getDefaultBranch() {
      try {
        const [defaultBranch] = await feathersClient.service("branches").find({
          query: {
            tenantId: this.selectedTenant.id,
            default: 1
          }
        });
        this.createForm.branchId = defaultBranch.id;
      } catch (error) {
        console.log(error)
      }
    },
    validateDestinations(destinations, type) {
      if (destinations.length > 1 && destinations.find((dst) => !dst.id)) {
        this.$notify({
          title: `Empty ${type} Destination field`,
          message: "Don't leave any destination field to be empty.",
          type: "error",
        });
        return;
      }

      let finalDestinations = [];
      if (destinations.length === 1 && destinations[0].id === null) {
        return finalDestinations;
      }

      if (destinations.length) {
        destinations.forEach((dst, idx) => (dst.order = idx + 1));

        finalDestinations = destinations.map(({ id, type, order }) => ({
          id,
          type,
          order,
        }));
      }
      return finalDestinations;
    },

    createOperation() {
      this.createForm.tenantId = this.selectedTenant.id;

      if (this.ringStrategy === "RINGALL") {
        this.createForm.dialTimeout = 300;
        this.enableLooping = false;
      }

      this.createForm.type = this.ringStrategy;
      this.createForm.type = this.enableLooping
        ? "CYCLE"
        : this.createForm.type;

      this.createForm.requestConfirm = this.requestConfirm ? "on" : "";

      const createBody = { ...this.createForm };

      const destinations = this.validateDestinations(
        createBody.destinations,
        "DESTINATIONS"
      );
      const timeoutDestinations = this.validateDestinations(
        createBody.timeoutDestinations,
        "TIMEOUT"
      );
      const unconditionalDestinations = this.validateDestinations(
        createBody.unconditionalDestinations,
        "UNCONDITIONAL"
      );
      if (timeoutDestinations && destinations && unconditionalDestinations) {
        createBody.timeoutDestinations = timeoutDestinations;
        createBody.unconditionalDestinations = unconditionalDestinations;
        createBody.destinations = destinations.slice(0, this.maxDests);
      } else {
        return;
      }

      //mutate unconditional status
      createBody.unconditionalStatus = createBody.unconditionalStatus
        ? "on"
        : "";

      const { branchId } = createBody;
      createBody.branchId = branchId ? branchId : null;

      this.$emit("createOperation", createBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    clearFields() {
      this.createForm = {
        tenantId: null,
        number: null,
        name: "",
        ringTime: null,
        type: "",
        usemoh: false,
        checkinuse: false,
        destinations: [
          {
            options: [],
            id: null,
            type: "",
            order: null,
          },
        ],
        phoneNums: [],
        timeoutDestinations: [],
        unconditionalStatus: "",
        unconditionalDestinations: [],
        requestConfirm: false,
        branchId: null,
      };

      this.activeTabName = "general";
      this.ringStrategy = "";
      this.enableLooping = false;
      this.requestConfirm = false;

      this.$emit("formsCleared");
    },

    remoteMethodForAvailableNums(query) {
      this.$emit("remoteMethodForAvailableNums", query);
    },

    onTimeoutDestinationsSelection(destinations) {
      this.createForm.timeoutDestinations = [...destinations];
    },

    onDestinationsSelection(destinations) {
      this.createForm.destinations = [...destinations];
    },
    onUnconditionalDestinationsSelection(destinations) {
      this.createForm.unconditionalDestinations = [...destinations];
    },
  },

  filters: {
    formatNumber(value) {
      return `(${value.substr(0, 3)}) ${value.substr(3, 3)}-${value.substr(
        6,
        4
      )}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.checkbox-group {
  max-width: 600px;
  margin: auto;
}

.el-tabs {
  max-width: 600px;
  margin: auto;
}

.inline-form-group .el-checkbox {
  margin-left: 0;
}

.el-checkbox {
  margin-left: 0;
}
</style>
